import React from "react";
import "./Background.css";

const Background = () =>{
    return(
    <div className="bubbles-container">
      {Array.from({ length: 20 }).map((_, i) => (
        <div key={i} className="bubble"></div>
      ))}
    </div>
    );
};

export default Background;